import * as api from "./client";

// ============================================================================
// Types
// ============================================================================

/** One asset a firm took. Rows are written once and never changed. */
export type DownloadAuditEntry = {
  id: string;
  takenAt: string;
  userId: string;
  userEmail: string;
  companyUuid: string;
  firmRef: string;
  ipAddress: string | null;
  assetKind: string;
  assetId: string;
  /** The firm or lawyer the asset names, copied at the time it was taken. */
  assetName: string | null;
  /** badge, copy_document, or one of the four bulk artefacts. */
  artefact: string;
  format: string | null;
  templateType: string | null;
  /** Whether the asset's own edition had launched when it was taken. */
  preRelease: boolean;
  /** Shared by every row of one bulk export, null for a single download. */
  exportId: string | null;
};

export type DownloadAuditResponse = {
  entries: DownloadAuditEntry[];
  pagination: { total: number; limit: number; offset: number; hasMore: boolean };
  requestId?: string | null;
};

export type DownloadAuditFilters = {
  firmRef?: string;
  preReleaseOnly?: boolean;
  takenFrom?: string;
  takenTo?: string;
  limit?: number;
  offset?: number;
};

// ============================================================================
// Service
// ============================================================================

function buildQuery(filters: DownloadAuditFilters): string {
  const params = new URLSearchParams();
  if (filters.firmRef) params.set("firmRef", filters.firmRef);
  if (filters.preReleaseOnly) params.set("preReleaseOnly", "true");
  if (filters.takenFrom) params.set("takenFrom", filters.takenFrom);
  if (filters.takenTo) params.set("takenTo", filters.takenTo);
  if (filters.limit !== undefined) params.set("limit", String(filters.limit));
  if (filters.offset !== undefined) params.set("offset", String(filters.offset));
  const query = params.toString();
  return query ? `?${query}` : "";
}

export const marketingDownloadAudit = {
  list: async (filters: DownloadAuditFilters = {}): Promise<DownloadAuditResponse> => {
    return api.get<DownloadAuditResponse>(`/v1/download-audit${buildQuery(filters)}`);
  },
};
